class SortBy extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', (event) => this.updateSortElements(event));
    this.defaultSortBy = this.getAttribute('data-sort-by-default');
  }

  /**
   * Update sort elements
   * @param {Object} event - Change event
   * @param {Object} event.target - Change event target
   *
   * @description Update all collection sort elements when the sort is changed
   */
  updateSortElements({ target: { value } }) {
    this.sortElements = this.sortElements || document.querySelectorAll('sort-by');

    // The 'element' variable is the current collection sort element. E.g. <sort-by>
    this.sortElements.forEach((element) => {
      // The 'select' variable is the select element inside the current collection sort element

      const radioButtons = element.querySelectorAll('input[type="radio"]');
      radioButtons.forEach((radio) => {
        if (radio.value !== value) {
          radio.removeAttribute('checked');
        } else {
          radio.setAttribute('checked', '');
        }
      });

      // Update the URL hash
      element.updateURL(value);
    });

    publish('sort:changed', {
      value,
    });
  }

  /**
   * Update URL
   * @param {String} value - URL value
   */
  updateURL(value) {
    const { searchParams } = new URL(window.location);
    searchParams.set('sort_by', value);
    searchParams.delete('page');

    // if value = default, remove the sort_by parameter from the URL
    if (this.defaultSortBy && value === this.defaultSortBy) {
      searchParams.delete('sort_by');
    }

    const newUrl = searchParams.size
      ? `${window.location.pathname}?${searchParams}`
      : window.location.pathname;
    history.replaceState(null, '', newUrl);
  }
}

customElements.define('sort-by', SortBy);
